/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_TasksInputs */

const cs_properties_bulk_transfer_tasks = /** @type {(inputs: Properties_Bulk_Transfer_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeřadit i otevřené úkoly`)
};

const en_properties_bulk_transfer_tasks = /** @type {(inputs: Properties_Bulk_Transfer_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also reassign open tasks`)
};

/**
* | output |
* | --- |
* | "Also reassign open tasks" |
*
* @param {Properties_Bulk_Transfer_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_tasks = /** @type {((inputs?: Properties_Bulk_Transfer_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_tasks(inputs)
	return cs_properties_bulk_transfer_tasks(inputs)
});